export default __webpack_public_path__ + "static/10-most-instagrammable-places-on-earth-fdf7fd36b8dcfc28659a1b2aca8160fe.jpg";